import {
  FORMAT_CATEGORIES_WITH_OTHER,
  type FormatCategoryWithOther,
} from "@garimpa/lib/formatGroups";
import type { ReleaseSearchFilter, StringMatcher } from "@garimpa/lib/searchState";

const VALID_FORMAT_CATEGORIES = new Set<string>(FORMAT_CATEGORIES_WITH_OTHER);

function singleMatcherValue(matcher: StringMatcher | undefined): string | undefined {
  if (typeof matcher === "string") return matcher;
  if (Array.isArray(matcher)) return matcher.length === 1 ? matcher[0] : undefined;
  return matcher?.all.length === 1 ? matcher.all[0] : undefined;
}

export function getSingleReleaseSearchFormat(
  filter: ReleaseSearchFilter | null | undefined,
): FormatCategoryWithOther | undefined {
  const value = singleMatcherValue(filter?.format);
  return value && VALID_FORMAT_CATEGORIES.has(value)
    ? (value as FormatCategoryWithOther)
    : undefined;
}
